import initialMessages from './index';

// Only these known build inputs can be requested; arbitrary locale paths never
// reach import(). Vite emits one lazy entry per supported language; unused source folders stay excluded.
const loaders = {
  './locale/ar/index.js': () => import('./locale/ar/index.js'),
  './locale/bg/index.js': () => import('./locale/bg/index.js'),
  './locale/ca/index.js': () => import('./locale/ca/index.js'),
  './locale/cs/index.js': () => import('./locale/cs/index.js'),
  './locale/da/index.js': () => import('./locale/da/index.js'),
  './locale/de/index.js': () => import('./locale/de/index.js'),
  './locale/el/index.js': () => import('./locale/el/index.js'),
  './locale/es/index.js': () => import('./locale/es/index.js'),
  './locale/et/index.js': () => import('./locale/et/index.js'),
  './locale/fa/index.js': () => import('./locale/fa/index.js'),
  './locale/fi/index.js': () => import('./locale/fi/index.js'),
  './locale/fr/index.js': () => import('./locale/fr/index.js'),
  './locale/he/index.js': () => import('./locale/he/index.js'),
  './locale/hi/index.js': () => import('./locale/hi/index.js'),
  './locale/hu/index.js': () => import('./locale/hu/index.js'),
  './locale/id/index.js': () => import('./locale/id/index.js'),
  './locale/it/index.js': () => import('./locale/it/index.js'),
  './locale/ja/index.js': () => import('./locale/ja/index.js'),
  './locale/ko/index.js': () => import('./locale/ko/index.js'),
  './locale/lv/index.js': () => import('./locale/lv/index.js'),
  './locale/ml/index.js': () => import('./locale/ml/index.js'),
  './locale/nl/index.js': () => import('./locale/nl/index.js'),
  './locale/no/index.js': () => import('./locale/no/index.js'),
  './locale/pl/index.js': () => import('./locale/pl/index.js'),
  './locale/pt/index.js': () => import('./locale/pt/index.js'),
  './locale/pt_BR/index.js': () => import('./locale/pt_BR/index.js'),
  './locale/ro/index.js': () => import('./locale/ro/index.js'),
  './locale/ru/index.js': () => import('./locale/ru/index.js'),
  './locale/sk/index.js': () => import('./locale/sk/index.js'),
  './locale/sr/index.js': () => import('./locale/sr/index.js'),
  './locale/sv/index.js': () => import('./locale/sv/index.js'),
  './locale/ta/index.js': () => import('./locale/ta/index.js'),
  './locale/th/index.js': () => import('./locale/th/index.js'),
  './locale/tr/index.js': () => import('./locale/tr/index.js'),
  './locale/uk/index.js': () => import('./locale/uk/index.js'),
  './locale/uz/index.js': () => import('./locale/uz/index.js'),
  './locale/vi/index.js': () => import('./locale/vi/index.js'),
  './locale/zh_TW/index.js': () => import('./locale/zh_TW/index.js'),
  './locale/is/index.js': () => import('./locale/is/index.js'),
  './locale/lt/index.js': () => import('./locale/lt/index.js'),
};
const dictionaries = new Map();
const selections = new WeakMap();
const composerFor = i18n => i18n.global || i18n;

export async function ensureLocale(i18n, requested) {
  const path = `./locale/${requested}/index.js`;
  const locale = Object.hasOwn(initialMessages, requested) ||
    Object.hasOwn(loaders, path) ? requested : 'en';
  let dictionary = initialMessages[locale];
  if (!dictionary) {
    if (!dictionaries.has(locale)) {
      const pending = Promise.resolve().then(() => loaders[path]()).then(module => module.default);
      dictionaries.set(locale, pending);
      pending.catch(() => {
        if (dictionaries.get(locale) === pending) dictionaries.delete(locale);
      });
    }
    dictionary = await dictionaries.get(locale);
  }
  composerFor(i18n).setLocaleMessage(locale, dictionary);
  return locale;
}

export async function applyLocale(i18n, requested) {
  const composer = composerFor(i18n);
  const selection = (selections.get(composer) || 0) + 1;
  selections.set(composer, selection);
  const locale = await ensureLocale(composer, requested);
  if (selections.get(composer) === selection) composer.locale.value = locale;
  return locale;
}
